import React from 'react';
import './ProgressBar.scss';

/**
 * Props for a {@link ProgressBar} component.
 * @author aga
 */
export type ProgressBarProps = {
  hidePercentageValue: boolean;
  percentage: number;
  textLines?: string[];
};

export function ProgressBar({
  hidePercentageValue,
  percentage,
  textLines
}: ProgressBarProps): JSX.Element {
  //Style
  const fillerStyles = {
    width: `${percentage}%`
  };
  return (
    <div className="ehs-progressbar">
      <div
        className="labelStyles"
        hidden={hidePercentageValue}
      >{`${percentage}%`}</div>
      <div className="progressStyles">
        <div className="fillerStyles" style={fillerStyles} />
      </div>

      {textLines?.map(value => {
        return (
          <div key={value} className="textStyles">
            {value}
          </div>
        );
      })}
    </div>
  );
}
